import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {Item} from "../../models/Item";
import {EsBsModalService} from "../../services/bsModalService/bs-modal.service";
import {UiAdapterService} from "@src/app/services/uiAdapterService/ui-adapter.service";

@Component({
  selector: 'app-vertex-option-button',
  templateUrl: './vertex-option-button.component.html',
  styleUrls: ['./vertex-option-button.component.scss']
})
export class VertexOptionButtonComponent implements OnInit, OnChanges {

  @Input() item: Item;
  // @Input() setting: {key: string, value: any};
  public Yiit = Yiit;

  constructor(private bs: EsBsModalService, private ui: UiAdapterService) { }

  ngOnInit() {
    // console.log('setting', this.setting);
    console.log('item', this.item);
    this.ui.selectedItem$.subscribe(() => {
      this.bs.closeModal(null, '#es-vertex-modal');
    });
  }

  ngOnChanges(){
    console.log('ngOnChanges()');
    // console.log('setting', this.setting);
    console.log('item', this.item);
  }

  openVertexModal() {
    this.bs.openModal({
      modalId: '#es-vertex-modal',
      backdrop: false,
      keyboard: false,
      modalConfig: {item: this.item}
    })
  }
}
